<script>
import CrudListVue from 'Support/components/crud/CrudList.vue';
import TaxScoreRequest from 'Domain/tax-score/TaxScoreRequest';
import DataTableTaxColumnVue from 'Support/components/data-table/DataTableColumns/DataTableTaxColumn.vue';
import DataTableCurrencyColumnVue from 'Support/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import TypeTaxColumnVue from '../components/TypeTaxColumn.vue';

export default {
  name: 'TaxScoreList',
  extends: CrudListVue,
  data() {
    return {
      requestClass: TaxScoreRequest,
      editRoute: 'taxScoreEdit',
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Tipo',
          value: 'tipo',
          component: TypeTaxColumnVue,
        },
        {
          text: 'Taxa',
          value: 'taxa',
          component: DataTableTaxColumnVue,
        },
        {
          text: 'Score mínimo',
          value: 'scoreMinimo',
        },
        {
          text: 'Score máximo',
          value: 'scoreMaximo',
        },
        {
          text: 'Valor mínimo',
          value: 'valorMinimo',
          component: DataTableCurrencyColumnVue,
        },
        {
          text: 'Valor máximo',
          value: 'valorMaximo',
          component: DataTableCurrencyColumnVue,
        },
      ],
    };
  },
};
</script>
